import type { Fighter } from '@/types'

export type { Fighter }

export const fighters: Fighter[] = [
  {
    id: 1,
    name: 'Islam Makhachev',
    nickname: "The Eagle's Successor",
    weightClass: 'Lightweight',
    record: '25-1-0',
    country: 'Russia',
    imageUrl: 'https://placehold.co/300x300/1a1a1a/d4af37?text=Islam',
    age: 33,
    height: "5'10\"",
    reach: '70.5"',
    stance: 'Orthodox',
    hometown: 'Makhachkala, Dagestan',
    fightingStyle: 'Sambo, Wrestling, Submission Grappling',
    wins: { ko: 4, sub: 11, dec: 10 },
    losses: { ko: 1, sub: 0, dec: 0 }
  },
  {
    id: 2,
    name: 'Jon Jones',
    nickname: 'Bones',
    weightClass: 'Heavyweight',
    record: '27-1-0',
    country: 'USA',
    imageUrl: 'https://placehold.co/300x300/1a1a1a/d4af37?text=Jones',
    age: 37,
    height: "6'4\"",
    reach: '84.5"',
    stance: 'Orthodox',
    hometown: 'Rochester, New York',
    fightingStyle: 'Wrestling, Muay Thai, BJJ',
    wins: { ko: 10, sub: 7, dec: 10 },
    losses: { ko: 0, sub: 0, dec: 1 }
  },
  {
    id: 3,
    name: 'Alex Pereira',
    nickname: 'Poatan',
    weightClass: 'Light Heavyweight',
    record: '11-2-0',
    country: 'Brazil',
    imageUrl: 'https://placehold.co/300x300/1a1a1a/d4af37?text=Pereira',
    age: 37,
    height: "6'4\"",
    reach: '79"',
    stance: 'Orthodox',
    hometown: 'São Paulo, Brazil',
    fightingStyle: 'Kickboxing, Muay Thai',
    wins: { ko: 9, sub: 0, dec: 2 },
    losses: { ko: 2, sub: 0, dec: 0 }
  },
  {
    id: 4,
    name: 'Ilia Topuria',
    nickname: 'El Matador',
    weightClass: 'Featherweight',
    record: '16-0-0',
    country: 'Spain',
    imageUrl: 'https://placehold.co/300x300/1a1a1a/d4af37?text=Topuria',
    age: 27,
    height: "5'7\"",
    reach: '69"',
    stance: 'Orthodox',
    hometown: 'Alicante, Spain',
    fightingStyle: 'Wrestling, Boxing, BJJ',
    wins: { ko: 7, sub: 5, dec: 4 },
    losses: { ko: 0, sub: 0, dec: 0 }
  },
  {
    id: 5,
    name: "Sean O'Malley",
    nickname: 'Sugar',
    weightClass: 'Bantamweight',
    record: '18-1-0',
    country: 'USA',
    imageUrl: 'https://placehold.co/300x300/1a1a1a/d4af37?text=Sugar',
    age: 29,
    height: "5'11\"",
    reach: '72"',
    stance: 'Switch',
    hometown: 'Helena, Montana',
    fightingStyle: 'Striking, Kickboxing',
    wins: { ko: 12, sub: 0, dec: 6 },
    losses: { ko: 0, sub: 0, dec: 1 }
  },
  {
    id: 6,
    name: 'Dricus Du Plessis',
    nickname: 'Stillknocks',
    weightClass: 'Middleweight',
    record: '22-2-0',
    country: 'South Africa',
    imageUrl: 'https://placehold.co/300x300/1a1a1a/d4af37?text=DDP',
    age: 30,
    height: "6'1\"",
    reach: '76"',
    stance: 'Orthodox',
    hometown: 'Pretoria, South Africa',
    fightingStyle: 'Boxing, Wrestling, BJJ',
    wins: { ko: 14, sub: 4, dec: 4 },
    losses: { ko: 1, sub: 0, dec: 1 }
  }
]

export function getFighterById(id: number): Fighter | undefined {
  return fighters.find(f => f.id === id)
}
